import React from "react";
import { Switch, Route, Redirect } from 'react-router-dom'
import httpClient from './httpClient';
import "./style/css/global_layout/App.css";
import "./style/css/particulier/cars.css";
import "./style/css/particulier/hebergement.css";
import "./style/css/particulier/voyage.css";
import "./style/css/particulier/paiment.css";
import "./style/css/pro/Admin.css"
import "./style/css/particulier/calendar.css"
import NavBar from "./components/common/global_layout/navBar";
import Footer from './components/common/global_layout/footer';
import LogOut from './components/insecription/LogOut';
import LoginModal from "./components/insecription/loginModal";
import Profile from './views/Pro/Profile'
import LoginSuperAdminForm from './components/insecription/LoginSuperAdminForm';
import LoginProForm from './components/insecription/LoginProForm';
import Admin from './views/superAdmin/Admin';
import DetailsGhurfaty from "./views/patricular/Hebergement/DetailsGhurfaty";
import Vols from "./views/patricular//Vols/vols";
import Cars from "./views/patricular//Cars/Cars";
import Divertissements from "./views/patricular/Divertissements";
import advancedSearchHebergement from './views/patricular/Hebergement/searchHberg';
import Location from './views/patricular/Cars/location';
import Transfert from './views/patricular/Cars/transfert'
import QuatreX4 from './views/patricular/Cars/carTypes/QuatreX4'
import CarDetails from './views/patricular/Cars/carDetails'




import Particular from "./views/patricular/particular";
import Agent from "./views/Pro/Agent";
import HebergReserv from "./components/common/Hebergement/hebergReserv";
import Visas from "./views/patricular/Visa/Visas";
import AdvencedSearchVisa from "./views/patricular/Visa/Advanced_searchVisa";
import DetailsVisa from "./views/patricular/Visa/detailsVisa";
import Voyage from "./views/patricular/Voyages/voygaes";
import Mondial_circuit from "./views/patricular/Voyages/mondialCircuit";
import Circuit_HajjOmra from "./views/patricular/Voyages/circuitHajOmra";
import Offres_hajj from "./views/patricular/Voyages/offres_hajj";
import Mon_Voyage_Omra from "./views/patricular/Voyages/mon_voyageOmra";
import Mon_panier_voyage from "./views/patricular/Voyages/mon_panier";
import DetailsVoyage from "./views/patricular/Voyages/DetailsVoyage";

import VolDetails from "./views/patricular/Vols/volDetails";
import SearchVol from "./views/patricular/Vols/volSearch";
import Panier from "./views/patricular/panier/panier";

import Histo from "./views/Pro/histo";
import Home from "./views/home";
import Messagerie from "./views/Pro/messagerie";
import Discussion from "./views/Pro/discussion";
import Profilesettings from "./views/Pro/profileSettings";
import Myannounces from "./views/Pro/myAnnounces";
import Notifications from "./views/Pro/notifications";

import { initCurrentUser } from "./slices/userSlice";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SearchLocation from "./views/patricular/Cars/SearchLocation";
import SearchTransfert from "./views/patricular/Cars/SearchTransfert";
import BasicDocument from "./components/common/pdfGenerator";

import 'react-phone-input-2/lib/style.css'


 

class App extends React.Component {
	state = { currentUser: httpClient.getCurrentUser() }

	componentDidMount() {
		this.props.dispatch(initCurrentUser(this.state.currentUser))
	  }

	onLoginSuccess(user) {
		this.setState({ currentUser: httpClient.getCurrentUser() })
	}

	logOut() {
		httpClient.logOut()
		this.setState({ currentUser: null })
	}
	
	render() {
		const { currentUser } = this.state
		const pdf  = this.props.pdf
		return (
			<div className='App'>
				{pdf && <BasicDocument />}
				{!pdf&&<>
					<NavBar currentUser={currentUser} />
  
  <LoginModal onLoginSuccess={this.onLoginSuccess.bind(this)}  onSignUpSuccess={this.onLoginSuccess.bind(this)}/>

  <Switch>


	  <Route path="/hebergReserv" component={HebergReserv} />
	  
	  <Route path='/divertissements' component={Divertissements} />


	  <Route path='/vols/volDetails/:token' component={VolDetails} />

	  <Route path='/vols/search' component={SearchVol} />


	  {/* <Route path='/vols/search' component={SearchVol} /> */}


	  <Route path='/vols' component={Vols} />


	  <Route path="/cars/:id_car/carDetails" currentUser={currentUser}render={(props) => {
		  return (currentUser
			  ? <CarDetails currentUser={currentUser}/>
			  : <CarDetails currentUser={""}/>)
	  }}/>
	  <Route path='/cars/location/advanced_search' component={SearchLocation} />

	  <Route path='/cars/transfert/advanced_search' component={SearchTransfert} />

	  <Route path="/cars/location/:type_voiture" component={QuatreX4} />

	  <Route path='/cars/location' component={Location} />

	  <Route path='/cars/transfert' component={Transfert} />

	  <Route path='/cars' component={Cars} currentUser= {currentUser}/>



	  <Route path="/hebergement/:id_hebergement/details"  render={(props) => {
		  return (currentUser
			  ? <DetailsGhurfaty currentUser={currentUser}/>
			  : <DetailsGhurfaty currentUser={""}/>)
	  }} />


	  <Route path="/cars/location/4X4/carDetails"  render={(props) => {
		  return (currentUser
			  ? <CarDetails currentUser={currentUser}/>
			  : <CarDetails currentUser={""}/>)
	  }} />
	  <Route path="/cars/location/berline/carDetails"  render={(props) => {
		  return (currentUser
			  ? <CarDetails currentUser={currentUser}/>
			  : <CarDetails currentUser={""}/>)
	  }} />
	  <Route path="/cars/location/citadine/carDetails"  render={(props) => {
		  return (currentUser
			  ? <CarDetails currentUser={currentUser}/>
			  : <CarDetails currentUser={""}/>)
	  }} />
	  <Route path="/cars/location/taxi/carDetails"  render={(props) => {
		  return (currentUser
			  ? <CarDetails currentUser={currentUser}/>
			  : <CarDetails currentUser={""}/>)
	  }} />


	  <Route path='/hebergement/advanced_search' component={advancedSearchHebergement} />

	  <Route path='/hebergement' component={Particular} currentUser= {currentUser}/>


	  <Route path="/logout" render={(props) => {
		  return <LogOut onLogOut={this.logOut.bind(this)} />
	  }} />


	 <Route path="/agent_Login" render={(props) => {
		  return  <LoginProForm form="true" onLoginSuccess={this.onLoginSuccess.bind(this)}/>

	  }} />

	  
	 <Route path="/super_admin_Login" render={(props) => {
		  return  <LoginSuperAdminForm form="true" onLoginSuccess={this.onLoginSuccess.bind(this)}/>

	  }} />

	  <Route path="/agent/profile/:id" render={(props) => {
		  return (currentUser
			  ? <Profile onSignUpSuccess={this.onLoginSuccess.bind(this)}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>
	   <Route path="/agent/profileSettings" render={(props) => {
		  return (currentUser
			  ? <Profilesettings onSignUpSuccess={this.onLoginSuccess.bind(this)}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>
	  <Route path="/agent/annonces" render={(props) => {
		  return (currentUser
			  ? <Myannounces onSignUpSuccess={this.onLoginSuccess.bind(this)} currentUser={currentUser}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>
	  <Route path="/agent/histo" render={(props) => {
		  return (currentUser
			  
			  ? <Histo onSignUpSuccess={this.onLoginSuccess.bind(this)}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>
	  <Route path="/agent/notifications" render={(props) => {
		  return (currentUser
			  ? <Notifications onSignUpSuccess={this.onLoginSuccess.bind(this)} currentUser={currentUser}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>

	  <Route path="/messagerie/:discussion" render={(props) => {
		  return (currentUser
			  ? <Discussion onSignUpSuccess={this.onLoginSuccess.bind(this)} currentUser={currentUser}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>
	  <Route path="/messagerie" render={(props) => {
		  return (currentUser
			  ? <Messagerie onSignUpSuccess={this.onLoginSuccess.bind(this)} currentUser={currentUser}/>
			  : <Redirect  to="/agent_Login" />)
	  }}/>

	 <Route path="/agent/:id"  render={(props) => {
		  return (currentUser
			  ? <Agent currentUser={currentUser}/>
			  : <Redirect  to="/agent_Login" />)
	  }} />
	  
	  <Route path="/super_admin" render={(props) => {
		  return (currentUser
			  ? <Admin />
			  : <Redirect  to="/super_admin_Login" />)
	  }} />

	  
	  {/* Visa */}
	  
	  <Route path='/visas/:id_visa/details' component={DetailsVisa} />
	  <Route path='/visas/advanced_search' component={AdvencedSearchVisa} />
	  <Route path='/visas' component={Visas} />


	  {/* Voyages */}

	  <Route path='/voyages/haj_omra_circuit/offres_hajj/mon_voyage/mon_panier' component={Mon_panier_voyage} />
	  <Route path='/voyages/haj_omra_circuit/offres_hajj/mon_voyage' component={Mon_Voyage_Omra} />
	  <Route path='/voyages/haj_omra_circuit/offres_hajj' component={Offres_hajj} />
	  <Route path='/voyages/haj_omra_circuit' component={Circuit_HajjOmra} />
	  <Route path='/voyages/mondial_circuit' component={Mondial_circuit} />
	  <Route path='/voyages/:id_voyage/details'  render={(props) => {
		  return (currentUser
			  ? <DetailsVoyage currentUser={currentUser}/>
			  : <DetailsVoyage currentUser={""}/>)
	  }} />
	  <Route path='/voyages' component={Voyage} />


	  {/* Panier */}
	  <Route path='/panier' component={Panier}/>



	  <Route path="/" render={(props) => {
		  return (<Home />)
	  }} />
  
  </Switch>
		</>}
				{!pdf&&<Footer />}
			</div>
			
		)
	}
}


function mapStateToProps(state) {
	return {
		pdf :state.showReservationHeberg.showPdf
	}
  }
  
  //connect function INJECTS dispatch function as a prop!!
  export default withRouter(connect(mapStateToProps)(App));